import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';

import { AppModule } from './app/app.module';
import { initOpenTelemetryIfEnabled } from './app/core/monitoring/otel-init';

// Antes do bootstrap: as instrumentações precisam envolver fetch/XHR e ler o timing de
// document load ANTES de o app fazer a primeira requisição, senão o carregamento inicial —
// justo o que mais interessa em Web Vitals — não é capturado.
initOpenTelemetryIfEnabled(environment);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

const currentHost: string = window.location.host;

const redirections = {
  'vault.legatusgrowth.com': 'app.cognitobrm.com',
  'vault-staging.legatusgrowth.com': 'staging.cognitobrm.com',
};

if (redirections[currentHost as keyof typeof redirections]) {
  const newDomain = redirections[currentHost as keyof typeof redirections];
  window.location.href = `https://${newDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;
}
